import styled from "styled-components";

export const OptInWinHighlightAmountDefaultBox = styled.div`
    font-size: 1.8rem;
    line-height: 1;
    font-weight: 900;
    font-stretch: extra-condensed;
    text-align: center;

    color: #FFED40;
    background: linear-gradient(180deg, #FFED40 0%, #FCD203 100%);         
    text-align: center;
    filter: drop-shadow(0px 1px #665501);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;